export const projects: IProjects = {
  p1: {
    id: 'p1',
    modifiedAt: '2024-11-17T16:37:00.630Z',
    name: 'Playground',
    thumbnail:
      'projectsthumbnails/google-oauth2|108507693505133121955-nice-f199ea35-f494-441c-91a2-a934f397e716.webp',
    type: 'asset-pack',
    emoji: '🔥',
    models: {
      m1: {
        id: 'm1',
        generatorId: '',
        modifiedAt: '',
        name: '',
        thumbnailUrl: '',
        source: 'unknown',
        valuesModel: {
          size: 1,
          gripType: 'FirmGrip',
        },
        materials: {
          m1: {
            id: 'M45',
            emission: 0,
            metalness: 0,
            roughness: 0,
            specular: 0,
            tint: '#ffffff',
            transparency: 0.5,
            texture: {
              id: 'T124',
              style: 'realistic',
            },
          },
        },
      },
    },
  },
};
